const fontFace = (
  format: string,
  family: string,
  weight: number,
  fileName: string,
) => {
  const woffFormat = `url('/fonts/${fileName}/${fileName}.woff2') format('woff2'),
            url('$/fonts/${fileName}/${fileName}.woff') format('woff')`;

  const ttfFormat = `url('/fonts/${fileName}.ttf') format('truetype');`;

  return `@font-face {
        font-family: ${family};
        font-style: normal;
        font-weight: ${weight};
        src: ${format === 'woff' ? woffFormat : ttfFormat};
  }`;
};

// prettier-ignore
export const fonts = `
    ${fontFace('woff', 'Open Sans', 400, 'open-sans-400')}
    ${fontFace('woff', 'Open Sans', 600, 'open-sans-600')}
    ${fontFace('woff', 'Open Sans', 700, 'open-sans-700')}
    ${fontFace('woff', 'Raleway', 400, 'raleway-modified-400')}
    ${fontFace('woff', 'Raleway', 600, 'raleway-modified-600')}
    ${fontFace('woff', 'Raleway', 700, 'raleway-modified-700')}
`;

export default fonts;
